import CardsSection from "./CardsSection/Index";
import Landing from "./LandingSection/Index";
import MultiStep from "./MultiStepComponent/Index";

export const components = [<Landing />, <MultiStep />, <CardsSection />];
